<template>
  <div class="container-fluid py-4">
    <h4 class="h4 font-weight-bold text-left text-capitalize">
      Crew Statement
    </h4>
    <hr />
    <div class="row mb-3">
      <div class="col-sm-6 d-flex align-items-center">
        <h5 class="h5 font-weight-bold text-left text-capitalize mb-0 mt-1">
          TNKC House
        </h5>
      </div>
      <div class="col-sm-6">
        <select class="form-control form-control-sm w-auto float-right m-0">
          <option>TNKC House</option>
          <option>ZEN Rooms</option>
        </select>
        <select class="form-control form-control-sm w-auto float-right my-0 mx-3"
                v-model="selectedMonth"
                @change="pickedMonth">
          <option v-for = "monthName in monthNames"
                  :value="monthName.id" :key="monthName.id">
            {{ monthName.name }}
          </option>
        </select>
      </div>
    </div>
    <table class="table table-striped table-sm table-bordered">
      <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">RANK</th>
        <th scope="col">CREW NAME</th>
        <th scope="col">CHECK IN</th>
        <th scope="col">CHECK OUT</th>
        <th scope="col">AMOUNT (PHP)</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <th scope="row">1</th>
        <td>C/E</td>
        <td>ACAS, MARK ALHEL MADERA</td>
        <td>01 Nov 2020</td>
        <td>30 Nov 2020</td>
        <td>10000</td>
      </tr>
      <tr>
        <th scope="row">2</th>
        <td>C/E</td>
        <td>ACAS, MARK ALHEL MADERA</td>
        <td>01 Nov 2020</td>
        <td>30 Nov 2020</td>
        <td>10000</td>
      </tr>
      <tr>
        <th scope="row">3</th>
        <td>C/E</td>
        <td>ACAS, MARK ALHEL MADERA</td>
        <td>01 Nov 2020</td>
        <td>30 Nov 2020</td>
        <td>10000</td>
      </tr>
      <tr>
        <th scope="row">4</th>
        <td>C/E</td>
        <td>ACAS, MARK ALHEL MADERA</td>
        <td>01 Nov 2020</td>
        <td>30 Nov 2020</td>
        <td>10000</td>
      </tr>
      <tr>
        <th scope="row">5</th>
        <td>C/E</td>
        <td>ACAS, MARK ALHEL MADERA</td>
        <td>01 Nov 2020</td>
        <td>30 Nov 2020</td>
        <td>10000</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "CrewStatement",
  data (){
    return {
      selectedMonth: 0,
      days: [],
      monthNames: [
          {id: 0, name:'January'},
          {id: 1, name:'February'},
          {id: 2, name:'March'},
          {id: 3, name:'April'},
          {id: 4, name:'May'},
          {id: 5, name:'June'},
          {id: 6, name:'July'},
          {id: 7, name:'August'},
          {id: 8, name:'September'},
          {id: 9, name:'October'},
          {id: 10, name:'November'},
          {id: 11, name:'December'},
      ]
    }
  },
  methods: {
    getDaysInMonth(month, year) {
      // let monthIndex = month - 1;
      let date = new Date(year, month, 1);
      let days = [];
      while (date.getMonth() === month) {
        days.push(date.getDate());
        date.setDate(date.getDate() + 1);
      }
      return this.days = days;
    },
    pickedMonth(){
      this.getDaysInMonth(this.selectedMonth,2020);
    }
  },
  created() {
    this.getDaysInMonth(this.selectedMonth,2020);
  },
}
</script>

<style scoped>

</style>